import { render, staticRenderFns } from "./SelectDiseases.vue?vue&type=template&id=64ef43cc&scoped=true"
import script from "./SelectDiseases.vue?vue&type=script&lang=js"
export * from "./SelectDiseases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef43cc",
  null
  
)

export default component.exports